module.exports = __webpack_public_path__ + "img/zxs.8459b5b2.jpg";